/* eslint-disable camelcase */
import React, {
    ComponentProps, useRef, useState
} from "react";
import { JobSearchHit, PageLayout } from "@themuse/design-system";

import SearchFacets from "components/facets/SearchFacets";
import SearchInput from "components/header/SearchInput";
import SearchFilterToggleBar from "components/toggle/SearchFilterToggleBar";
import { SearchResults } from "components/content/SearchResults";
import { useUserState } from "hooks/UserContext";
import { useFeatureFlagsState } from "hooks/FeatureFlagsContext";
import { SearchHistoryProvider, useSearchHistory } from "hooks/SearchHistoryContext";
import styles from "styles/Home.module.scss";
import { newsletterSubscribeRequest } from "utils/api";
import { BrowseLinks } from "./BrowseLinks";
import { SideBySideJDP } from "./SideBySideJDP";

export const SearchPageLayout = () => {
    const user = useUserState();
    const { addHistory } = useSearchHistory();
    const { FEATURE_FLAG_TWO_PANE = false } = useFeatureFlagsState();

    const pageLayoutProps: ComponentProps<typeof PageLayout> = {
        activePath: "/search",
        headerClassName: styles.pageHeader,
        footerClassName: styles.pageFooter,
        pageName: styles.pageWrapper,
        mainClassName: styles.main,
        showSubMenus: true,
        user,
        handleModalFormSubmit: newsletterSubscribeRequest
    };

    const [filterOpen, setFilterOpen] = useState(false);
    const [clearInputs, setClearInputs] = useState(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedJob, setSelectedJob] = useState<JobSearchHit>(null);

    const contentRef = useRef<HTMLElement>(null);
    const iframeRef = useRef<HTMLDivElement>(null);

    const handleClose = () => {
        setFilterOpen(false);
    };

    const clearSearch = () => {
        setClearInputs(true);
        addHistory();
    };

    const inputsCleared = () => {
        setClearInputs(false);
        addHistory();
    };

    return (
        <PageLayout {...pageLayoutProps}>
            <SearchHistoryProvider>
                <section className={styles.header}>
                    <SearchInput
                        clearInputs={clearInputs}
                        onClear={inputsCleared}
                    />
                </section>
                <section className={styles.filterToggle}>
                    <SearchFilterToggleBar
                        open={filterOpen}
                        onToggle={(open) => setFilterOpen(open)}
                    />
                </section>
                <aside className={`${styles.sidebar} ${filterOpen ? styles.showSidebar : ""}`}>
                    <SearchFacets onClose={handleClose} onFiltersChange={() => undefined} />
                </aside>
            </SearchHistoryProvider>
            <article ref={contentRef} className={styles.content}>
                <SearchResults
                    onClear={clearSearch}
                    {...{ setIsOpen, setSelectedJob }}
                />
                <BrowseLinks />
            </article>
            {FEATURE_FLAG_TWO_PANE ? (
                <SideBySideJDP {...{
                    contentRef,
                    iframeRef,
                    isOpen,
                    setIsOpen,
                    selectedJob,
                    setSelectedJob
                }}
                />
            ) : null}
        </PageLayout>
    );
};
